import { useQueryClient } from '@tanstack/react-query';

export const useClearMutationCache = () => {
  const queryClient = useQueryClient();
  const mutationCache = queryClient.getMutationCache();

  return (mutationKey: string[]) =>
    mutationCache.findAll({ mutationKey }).forEach((m) => {
      mutationCache.remove(m);
    });
};

export const useIsMutationCancelled = () => {
  const queryClient = useQueryClient();
  const mutationCache = queryClient.getMutationCache();

  return (mutationKey: string[]) => mutationCache.findAll({ mutationKey }).length === 0;
};
